module.exports = __webpack_public_path__ + "static/img/bg.47a57cdf.jpg";